import { AxiosResponse } from "axios";
import { oc } from "ts-optchain";

import { DealernetApi } from "./DealernetApi";

import {
    IAllPartSearchLogDto,
    ITruckModelSearchLogDto
} from "@/types";

export class RecentActivityService {
    public static async getRecentTruckModelSearches(userId: number): Promise<ITruckModelSearchLogDto[]> {
        const response = await DealernetApi.client().request({
            method: "get",
            url: `RecentActivity/GetRecentTruckModelSearches?userId=${userId}`
        });
        const data = oc(response as AxiosResponse<ITruckModelSearchLogDto[]>).data([]);
        return data;
    }

    public static async getRecentPartSearches(userId: number): Promise<IAllPartSearchLogDto[]> {
        const response = await DealernetApi.client().request({
            method: "get",
            url: `RecentActivity/GetRecentPartSearches?userId=${userId}`
        });
        const data = oc(response as AxiosResponse<IAllPartSearchLogDto[]>).data([]);
        return data;
    }


}
